/* Zailarah - favourites (wishlist). Saved in the visitor's browser (localStorage "zl-favs": list of product handles).
   [data-fav="handle"] buttons toggle a product, [data-fav-count] shows the number (header), [data-fav-page] renders the
   saved products (sections/zl-favourites.liquid) from /products/<handle>.js. Plain ES2019, no dependencies. */
(function () {
  'use strict';
  if (window.ZLFav) return;
  var KEY = 'zl-favs', doc = document;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.7 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.4 0 5.5 3.3 4.3 6.7-1.7 4.7-9.2 9.3-9.2 9.3Z"/></svg>';

  function read() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) { /* private mode */ } sync(); }
  function toggle(h) { var a = read(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); write(a); return i < 0; }
  function money(c) { return window.ZL && window.ZL.money ? window.ZL.money(c) : (c / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sync() {
    var a = read();
    [].forEach.call(doc.querySelectorAll('[data-fav]'), function (b) {
      var on = a.indexOf(b.getAttribute('data-fav')) > -1;
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var label = on ? (b.getAttribute('data-label-on') || 'Remove from favourites') : (b.getAttribute('data-label-off') || 'Add to favourites');
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
    });
    [].forEach.call(doc.querySelectorAll('[data-fav-count]'), function (c) {
      var hide = a.length === 0;
      if (c.hidden !== hide) c.hidden = hide;
      var n = c.querySelector('b');
      if (n && n.textContent !== String(a.length)) n.textContent = a.length;
    });
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-fav'));
    b.classList.remove('is-pop');
    void b.offsetWidth;
    if (on) b.classList.add('is-pop');
    var card = b.closest('[data-fav-item]');
    if (card && !on) { card.remove(); emptyCheck(); }
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  /* cards added later (collection filters, load more, recommendations) */
  var timer = null;
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { clearTimeout(timer); timer = setTimeout(sync, 150); return; }
    }
  }).observe(doc.documentElement, { childList: true, subtree: true });

  /* ---------------------------------------------------------------- favourites page */
  function emptyCheck() {
    var page = doc.querySelector('[data-fav-page]');
    if (!page) return;
    var grid = page.querySelector('[data-fav-grid]'), empty = page.querySelector('[data-fav-empty]');
    var none = !grid || !grid.children.length;
    if (empty) empty.hidden = !none;
    if (grid) grid.hidden = none;
  }

  function renderPage() {
    var page = doc.querySelector('[data-fav-page]');
    if (!page) return;
    var grid = page.querySelector('[data-fav-grid]'), list = read();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var viewLabel = page.getAttribute('data-view-label') || 'View product';
    var soldOut = page.getAttribute('data-sold-out') || 'Sold out';
    if (!list.length) { emptyCheck(); return; }
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var keep = [], html = '';
      products.forEach(function (p, i) {
        if (!p) return;
        keep.push(list[i]);
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var was = p.compare_at_price > p.price ? '<s>' + esc(money(p.compare_at_price)) + '</s>' : '';
        html += '<article class="zl-favcard" data-fav-item>' +
          '<a class="zl-favcard__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="zl-fav zl-fav--card" data-fav="' + esc(list[i]) + '" aria-pressed="true" data-label-off="Add to favourites" data-label-on="Remove from favourites" aria-label="Remove from favourites">' + HEART + '</button>' +
          '<div class="zl-favcard__info"><a class="zl-favcard__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<p class="zl-favcard__p">' + esc(money(p.price)) + was + (p.available ? '' : ' · <span class="zl-favcard__out">' + esc(soldOut) + '</span>') + '</p>' +
          '<a class="zl-favcard__btn" href="' + esc(p.url) + '">' + esc(viewLabel) + '</a></div></article>';
      });
      if (keep.length !== list.length) write(keep);   /* products that no longer exist */
      grid.innerHTML = html;
      sync();
      emptyCheck();
    });
  }

  /* ---------------------------------------------------------------- account drawer (mobile header) */
  var adr = null, adrOpener = null;
  function adrFavs() {
    var box = adr && adr.querySelector('[data-acct-favs]'), empty = adr && adr.querySelector('[data-acct-favs-empty]');
    if (!box) return;
    var list = read().slice(0, 4), root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (empty) empty.hidden = list.length > 0;
    if (!list.length) { box.innerHTML = ''; return; }
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      box.innerHTML = ps.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        return '<a href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>';
      }).join('');
    });
  }
  function adrKey(e) { if (e.key === 'Escape') adrClose(); }
  function adrOpen(opener) {
    adr = adr || doc.querySelector('[data-acct-drawer]');
    if (!adr) return false;
    if (adr.parentNode !== doc.body) doc.body.appendChild(adr);   /* never trapped inside a transformed header */
    adrOpener = opener;
    adr.hidden = false;
    doc.documentElement.classList.add('zl-adr-lock');
    adrFavs();
    sync();
    setTimeout(function () {
      adr.classList.add('is-open');
      var p = adr.querySelector('.zl-adr__panel');
      if (p) p.focus({ preventScroll: true });
    }, 20);
    doc.addEventListener('keydown', adrKey);
    return true;
  }
  function adrClose() {
    if (!adr || adr.hidden) return;
    adr.classList.remove('is-open');
    doc.documentElement.classList.remove('zl-adr-lock');
    doc.removeEventListener('keydown', adrKey);
    setTimeout(function () { adr.hidden = true; }, 300);
    if (adrOpener && adrOpener.focus) adrOpener.focus({ preventScroll: true });
  }
  doc.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-acct-open]');
    if (o) { if (adrOpen(o)) e.preventDefault(); return; }
    if (e.target.closest && e.target.closest('[data-acct-close]')) { e.preventDefault(); adrClose(); }
  });

  window.ZLFav = { read: read, toggle: toggle, sync: sync, openAccount: adrOpen, closeAccount: adrClose };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { sync(); renderPage(); });
  else { sync(); renderPage(); }
})();
